// extracted by mini-css-extract-plugin
export default {"backgroundWrapper":"ProductsPage_backgroundWrapper__szUkE"};